import { TextField, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useField } from "formik";
import { useState } from "react";

type InputFieldProps = {
  name: string;
  label: string;
  className?: string;
  type?: string;
  showPasswordToggle?: boolean;
};

export default function InputField({
  name,
  label,
  className,
  type,
  showPasswordToggle,
}: InputFieldProps) {
  const [field, meta] = useField(name);
  const [showPassword, setShowPassword] = useState(false);

  const hasError = Boolean(meta.touched && meta.error);

  const inputType =
    showPasswordToggle && type === "password"
      ? showPassword
        ? "text"
        : "password"
      : type;

  return (
    <TextField
      {...field}
      name={name}
      label={label}
      type={inputType}
      className={className}
      error={hasError}
      helperText={hasError ? meta.error : ""}
      slotProps={{
        input: {
          endAdornment:
            showPasswordToggle && type === "password" ? (
              <InputAdornment position="end">
                <IconButton
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge="end"
                  aria-label="toggle password visibility"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ) : undefined,
        },
      }}
    />
  );
}